import type { ChangeRequest, ChangeStatus, ChangeUrgency, InitiativeKind } from '@/api/types';
import type { Tone } from '@/components/ui';

/** «Идеи и запросы»: one vocabulary for the client's and the studio's screens. */
export const initiativeStatus: Record<ChangeStatus, { tone: Tone; client: string; studio: string }> = {
  new: { tone: 'active', client: 'Получили, разбираем', studio: 'Новая' },
  question: { tone: 'waiting', client: 'Студия спрашивает', studio: 'Ждём ответа клиента' },
  estimated: { tone: 'waiting', client: 'Ждёт вашего решения', studio: 'Оценка у клиента' },
  in_scope: { tone: 'done', client: 'Взяли в работу', studio: 'В работе' },
  accepted: { tone: 'done', client: 'Принято, в работе', studio: 'Принято' },
  declined: { tone: 'neutral', client: 'Не берём', studio: 'Не берём' },
  parked: { tone: 'neutral', client: 'Отложили', studio: 'Отложено' },
  done: { tone: 'done', client: 'Готово', studio: 'Готово' },
};

export const urgencyLabel: Record<ChangeUrgency, string> = { low: 'Не срочно', month: 'В этом месяце', urgent: 'Срочно' };

export const kindLabel: Record<InitiativeKind, string> = { site: 'Сайт', ads: 'Реклама', analytics: 'Аналитика', content: 'Контент', other: 'Другое' };

/** Statuses where the studio still decides: take, estimate, ask, park, decline. */
export const isOpen = (c: Pick<ChangeRequest, 'status'>) => c.status === 'new' || c.status === 'question' || c.status === 'parked';

/** The studio's note when it took the initiative into work (the last «in scope» step). */
export const takeNote = (c: ChangeRequest) => c.history?.findLast((e) => e.kind === 'in_scope')?.note;

/** The client answered the studio's question and the initiative is back with the studio. */
export const answered = (c: ChangeRequest) => c.status === 'new' && c.history?.at(-1)?.kind === 'answered';

/** Filed by a client's system through a key (MK42-6384); older records know it by the author's name only. */
export const viaApi = (c: Pick<ChangeRequest, 'author'>) => c.author.kind === 'api' || c.author.name.startsWith('Интеграция «');

/** The initiative in the client's own system: only an http(s) link is ever made clickable. */
export const externalLink = (c: Pick<ChangeRequest, 'externalUrl'>) => (c.externalUrl && /^https?:\/\//i.test(c.externalUrl) ? c.externalUrl : undefined);
